import React, { useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import "./SidebarModule.scss";

import { ReactComponent as CloseIcon } from 'static/icons/close-small.svg';
import { ReactComponent as Collection } from 'static/icons/collection.svg';
import { ReactComponent as Templates } from 'static/icons/templates.svg';
import { ReactComponent as Crown } from 'static/icons/crown.svg';
import { ReactComponent as ReportIcon } from 'static/icons/report-bars.svg';

import SidebarProject from "../SidebarProject";
import { checkPremium } from "utils/helpers";
import ModalComponent from "../../modals/ModalComponent";
import GoToPremiumModal from "../../modals/GoToPremiumModal";
import SidebarCollections from "../SidebarCollections";
import SidebarQBSReports from "../SidebarQBSReports";
import { t } from "i18next";

const SidebarModule = ({
  isOpened,
  onChangeSidebar
}) => {
   const { subscreption } = useSelector((state) => state.user.info);

  const [moduleContent, setModuleContent] = useState("template");
  const [isPremiumModalVisible, setPremiumModalVisible] = useState(false);

  const IS_PREMIUM = checkPremium(subscreption);

  const handleCloseClick = () => {
    onChangeSidebar?.(false);
  };

  const handleOpenClick = () => {
    if (!isOpened) {
      onChangeSidebar?.(true);
    }
  };

  const setActiveClass = (icon) => {
    return moduleContent === icon && isOpened ? "_active" : "";
  }

  const handleClosePremiumModal = () => {
    setPremiumModalVisible(false);
  };

  const handleOpenPremiumModal = (e) => {
    if (!IS_PREMIUM) {
      e.stopPropagation();
      setPremiumModalVisible(true);
    }
  };

  return (
    <>
      <div
        className={classNames({
          'sidebar-module': true,
          'sidebar-module--closed': !isOpened,
        })}
      >
        <div className="sidebar-module__header">
          <div
            className="sidebar-module__close-block"
            onClick={handleCloseClick}
          >
            <CloseIcon className="sidebar-module__header_close-icon" />
          </div>
        </div>

        <div className="sidebar-module__content">
          {
            moduleContent === "template" ?
              <SidebarProject /> :
              moduleContent === "collection" ?
                <SidebarCollections /> :
                <SidebarQBSReports />
          }
        </div>
      </div>
      <div
        className="quick-menu"
        onClick={handleOpenClick}
      >
        <div className="quick-menu__wrapper-item">
          <Templates className={`quick-menu__template-icon${setActiveClass("template")}`}
            onClick={() => setModuleContent("template")} />
        </div>
        <div className="quick-menu__wrapper-item" onClickCapture={(e) => handleOpenPremiumModal(e)}>
          <Collection className={`quick-menu__collection-icon${setActiveClass("collection")}`}
            onClick={() => setModuleContent("collection")} />
          {
            !IS_PREMIUM && <div className="quick-menu__crown"><Crown /></div>
          }
        </div>
        <div
          className={classNames(
            "quick-menu__wrapper-item",
            "quick-menu__wrapper-item--tooltip",
            { "quick-menu__wrapper-item--tooltip_active": moduleContent === "reports" && isOpened }
          )}
          onClick={() => {
            setModuleContent("reports");
            handleOpenClick();
          }}
        >
          <ReportIcon className={`quick-menu__report-icon${setActiveClass("reports")}`} />
          <div className="quick-menu__tooltip">
            <div className="quick-menu__tooltip-title">{t("execution_report")}</div>
            <div className="quick-menu__tooltip-text">
              {t("execution_report_hint_description")}
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        onCloseModal={handleClosePremiumModal}
        isVisible={isPremiumModalVisible}
      >
        <GoToPremiumModal
          text="<p>Premium version allows you to save templates endlessly, save elements as you wish, and much more.</p>
                <br/>
                <p>Take a look at our site to best understand what the premium upgrade has to offer!</p>"
        />
      </ModalComponent>
    </>
  );
};

export default SidebarModule;